import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { InputBase } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5px",
    borderRadius: "4px",
    alignItems: "center",
    display: "flex",
  },
  input: {
    flexGrow: 1,
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "-0.05px",
  },
  search: {
    position: "relative",
    borderStyle: "solid",
    borderColor: "#c4c4c4",
    borderRadius: theme.shape.borderRadius,
    border: "1px",
    backgroundColor: "#F5F7FA",
    "&:hover": {
      backgroundColor: "#F5F7FA",
    },
    marginTop: theme.spacing(1.8),
    marginRight: theme.spacing(1),
    marginLeft: 0,
    width: "100%",
  },
  searchIcon: {
    padding: theme.spacing(0, 0),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    borderColor: "#000",
  },
  inputInput: {
    fontSize: "15px",
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));

const SearchInput = ({ handleChange, placeholder = "Pesquisar" }, props) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.search, classes.root)}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <InputBase
        placeholder={placeholder}
        onChange={handleChange}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
      />
    </div>
  );
};

export default SearchInput;
